/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'youtube-color': {
    width: 40,
    height: 40,
    viewBox: '0 0 40 40',
    data: '<path pid="0" d="M0 20C0 8.954 8.954 0 20 0s20 8.954 20 20-8.954 20-20 20S0 31.046 0 20Z" _fill="red"/><path pid="1" fill-rule="evenodd" clip-rule="evenodd" d="M20 12.222s6.95 0 8.683.464a2.783 2.783 0 0 1 1.964 1.965c.464 1.733.464 5.349.464 5.349s0 3.616-.464 5.349a2.783 2.783 0 0 1-1.964 1.964c-1.733.465-8.683.465-8.683.465s-6.949 0-8.682-.465a2.783 2.783 0 0 1-1.964-1.964c-.465-1.733-.465-5.35-.465-5.35s0-3.615.465-5.348a2.783 2.783 0 0 1 1.964-1.965c1.733-.464 8.682-.464 8.682-.464Zm-3.333 4.445v6.666L23.334 20l-6.667-3.333Z" _fill="#fff"/>'
  }
})
